
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.188-1.719L32.907 5l-6.719 6.719-1.406-1.438L29.063 6H8V4h21.063L24.782-.281zm-12.375 14l1.406 1.438L10.938 18h21.063v2H10.938l4.281 4.281-1.406 1.438L7.094 19l.719-.719z"}})])
          )
        }
      }
    